import { useEffect, useState } from 'react';
import { AccessibilityInfo } from 'react-native';

/**
 * The OS-level "Reduce Motion" accessibility preference, kept in sync via
 * AccessibilityInfo's change event. Same pattern already used ad hoc in
 * TonyteLoadingScreen.tsx and chat/ChatAtmosphere.tsx — extracted here so a
 * third (and future) caller doesn't have to re-duplicate it. Defaults to
 * `false` until the initial async check resolves, matching those two
 * call sites' existing behavior (a one-time entrance animation briefly
 * playing before a slow initial check resolves is a much smaller cost than
 * every component independently re-implementing this).
 */
export function useReducedMotionPreference(): boolean {
  const [reduceMotion, setReduceMotion] = useState(false);

  useEffect(() => {
    let mounted = true;
    AccessibilityInfo.isReduceMotionEnabled()
      .then(value => { if (mounted) setReduceMotion(value); })
      .catch(() => undefined);
    const subscription = AccessibilityInfo.addEventListener?.('reduceMotionChanged', setReduceMotion);
    return () => {
      mounted = false;
      subscription?.remove?.();
    };
  }, []);

  return reduceMotion;
}
